import { COOKIES } from "@/constants/cookies";
import axios from "axios";
import { parseCookies } from "nookies";

export const apiWobaBackend = axios.create({
  baseURL: import.meta.env.VITE_WOBA_BACKEND_API,
});

apiWobaBackend.interceptors.request.use((config) => {
  let authCookie = parseCookies()[COOKIES.BACKOFFICE_AUTH];

  if (!authCookie) {
    authCookie = parseCookies()[COOKIES.U_TOKEN];
  }

  if (authCookie) {
    config.headers["auth-token"] = authCookie;
    config.headers["Authorization"] = `Bearer ${authCookie}`;
  }

  return config;
});
